<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  created() {
    
  }
}

</script>
<style>
 @import './assets/style/reset.css';
 @import './assets/style/element.css';
#app {
    font-family: "Microsoft YaHei", Avenir, Helvetica, Arial, sans-serif, "PingFangSC-Regular,PingFang SC";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width:100%;
    height:100%;
    display: flex;
}

html,
body,
div,
p,
b,
h1,
h2,
h3,
h4,
h5,
h6,
table,
tr,
th,
td,
thead,
tbody,
input,
textarea,
ul,
ol,
dl,
li,
input,
text {
  padding: 0;
  margin: 0;
  font-family: "Microsoft YaHei", Avenir, Helvetica, Arial, sans-serif, "PingFangSC-Regular,PingFang SC", "苹方黑体-中黑-简";
}

ul,
ol,
dl {
  list-style-type: none;
}

a {
  text-decoration: none;
}

input:focus,
textarea:focus {
  outline: none;
}

body {
  background: #F4F4F4;
}

input:focuse,
textarea:focus {
  outline: none;
}


  /* 修复有固定列时滚动到底部表格行没对齐的bug */
 /* 设置滚动条的样式 */
 ::-webkit-scrollbar {
      width: 10px !important;
      height:10px !important;
      background-color: #8487879e;
  }
 
  .el-table__fixed::before, .el-table__fixed-right::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: unset;
    z-index: 4;
  }  

  /* 修复有固定列时滚动到底部表格行没对齐的bug */


.el-table th>.cell {
  padding-left: 14px;
}

</style>
